import { Body, Controller, Get, Param, Post, Query, Req, Res, UploadedFiles, UseInterceptors } from '@nestjs/common';
import { errorHandler } from '@gtpl/shared-utils/error-messages';
import { ApiConsumes, ApiHeader, ApiOperation, ApiParam, ApiQuery, ApiTags } from '@nestjs/swagger';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { InchargeService } from './incharge.service';
import { AllResponseModel, SingleResponseModel } from './dto/incharge-response-model';
import { ChildInchargeDto, InchargeDTO, PaginationDto, TransformDto } from './dto/incharge.dto';
import { FileFieldsInterceptor, FilesInterceptor } from '@nestjs/platform-express';
import { extname } from 'path';
import { diskStorage } from 'multer';
import { imageFileFilter } from '../shared/file-upload';

@ApiTags('Incharge')
@Controller('incharge')
export class InchargeController {
    constructor (
        private inchrgServ: InchargeService,
    ){}


    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })  
    @Get('/getMandals') 
    @ApiQuery({name:'apiVersion'})
    async getMandals(@Query() queryParams, @Req() request:Request):Promise<AllResponseModel> {
        try {
            return await this.inchrgServ.getMandals(queryParams,request);
        } catch (error) {
            return errorHandler(AllResponseModel, error);
        }
    }

   

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })  
    @Get('/getVillages/:Mandalid') 
    @ApiQuery({name:'apiVersion'})
    @ApiParam({name:'Mandalid'})
    async getVillages(@Query() queryParams, @Param('Mandalid') Mandalid, @Req() request:Request):Promise<AllResponseModel> {
        try {
            return await this.inchrgServ.getVillages(queryParams,Mandalid,request);
        } catch (error) {
            return errorHandler(AllResponseModel, error);
        }
    }


    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })  
    @Get('/getParliament/:Distid') 
    @ApiQuery({name:'apiVersion'})
    @ApiParam({name:'Distid'})
    async getParliament(@Query() queryParams, @Param('Distid') Distid, @Req() request:Request):Promise<AllResponseModel> {
        try {
            return await this.inchrgServ.getParliament(queryParams,Distid,request);
        } catch (error) {
            return errorHandler(AllResponseModel, error);
        }
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })  
    @Get('/getAssembly/:Parlmntid') 
    @ApiQuery({name:'apiVersion'})
    @ApiParam({name:'Parlmntid'})
    async getAssembly(@Query() queryParams, @Param('Parlmntid') Parlmntid, @Req() request:Request):Promise<AllResponseModel> {
        try {
            return await this.inchrgServ.getAssembly(queryParams,Parlmntid,request);
        } catch (error) {
            return errorHandler(AllResponseModel, error);
        }
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })  
    @Get('/getBenefits') 
    @ApiQuery({name:'apiVersion'})
    async getBenefits(@Query() queryParams, @Req() request:Request):Promise<AllResponseModel> {
        try {
            return await this.inchrgServ.getBenefits(queryParams,request);
        } catch (error) {
            return errorHandler(AllResponseModel, error);
        }
    }


    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })  
    @Get('/getIncharges') 
    @ApiQuery({name:'apiVersion'})
    @ApiQuery({name:'searchTerm'})
    async getIncharges(@Query() queryParams, @Req() request:Request):Promise<AllResponseModel> {
        try {
            return await this.inchrgServ.getIncharges(queryParams,request);
        } catch (error) {
            return errorHandler(AllResponseModel, error);
        }
    }
   

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/addIncharge')
    @ApiQuery({name:'apiVersion'})
    @UseInterceptors(
		FilesInterceptor('Image', 1, {
			fileFilter: imageFileFilter,
			storage: diskStorage({
				destination: './public/inchargePic',
				filename: function (req, file, callback) {
					const name = file.originalname.split('.')[0];
					const fileExtName = extname(file.originalname);
					const randomName = Array(4)
						.fill(null)
						.map(() => Math.round(Math.random() * 16).toString(16))
						.join('');
					callback(null, `${name}-${randomName}${fileExtName}`);
				}
			}),			
		}),
    )
    @ApiConsumes('multipart/form-data')
    async addIncharge(@Query() queryParam,@UploadedFiles() Image,@Body() inchdto:InchargeDTO,@Req() request:Request): Promise<SingleResponseModel> {
        try {
            const response = [];
            Image.forEach(file => {
                const fileReponse = {
                    ImageLocation: `incharge/inchargePic/${file.filename}`,                               
                };
               response.push(fileReponse);
            })
            return await this.inchrgServ.addIncharge(queryParam, response,inchdto,request);            
        } catch (error) {
            return errorHandler(SingleResponseModel, error);
        }
    }

    @Get('/inchargePic/:imgpath')
    @ApiOperation({summary:'picture display'})
    @ApiParam({name:'imgpath'})
    async seeUploadedPic(@Param('imgpath') Image, @Res() res) {
		try {
			return res.sendFile(Image, { root: './public/inchargePic' });
		} catch (error) {
			return error.message;
		}
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Get('/getInchargeById/:Id')
    @ApiQuery({name:'apiVersion'})
    @ApiParam({name:'Id'})
    async getInchargeById(@Query() queryParams,@Param('Id') Id, @Req() request:Request): Promise<SingleResponseModel> {
        try {
            return await this.inchrgServ.getInchargeById(queryParams, Id, request);
        } catch (error) {
            return errorHandler(SingleResponseModel, error);
        }
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })  
    @Post('/editIncharge')
    @ApiQuery({name:'apiVersion'})
    @UseInterceptors(
		FilesInterceptor('Image', 1, {
			fileFilter: imageFileFilter,
			storage: diskStorage({
				destination: './public/inchargePic',
				filename: function (req, file, callback) {
					const name = file.originalname.split('.')[0];
					const fileExtName = extname(file.originalname);
					const randomName = Array(4)
						.fill(null)
						.map(() => Math.round(Math.random() * 16).toString(16))
						.join('');
					callback(null, `${name}-${randomName}${fileExtName}`);
				}
			}),			
		}),
    )
    @ApiConsumes('multipart/form-data')
    async editIncharge(@Query() queryParams,@UploadedFiles() Image,@Body() inchdto:InchargeDTO,@Req() request:Request): Promise<SingleResponseModel> {
        try {
            const response = [];
            Image.forEach(file => {
                const fileReponse = {
                    ImageLocation: `incharge/inchargePic/${file.filename}`,                               
                };
               response.push(fileReponse);
            })
            return await this.inchrgServ.editIncharge(queryParams,response,inchdto,request);
        } catch (error) {
            return errorHandler(SingleResponseModel, error);
        }
    }


    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Get('/getAllIncharges/:userId')
    @ApiParam({name:'userId'})
    @ApiQuery({name:'apiVersion'})
    @ApiQuery({name:'skip'})
    @ApiQuery({name:'VillageID', required:false})
    @ApiQuery({name:'BoothNo', required:false})
    @ApiQuery({name:'SerialNo', required:false})
    @ApiQuery({name:'FirstName', required:false})
    @ApiQuery({name:'VoterID', required:false})
     
    async getAllIncharges(@Query() pagDto:PaginationDto, @Param('userId') userId,@Req() request:Request):Promise<AllResponseModel> {
        try {
            return await this.inchrgServ.getAllIncharges(pagDto, userId, request);
        } catch (error) {
            return errorHandler(AllResponseModel, error);
        }
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Get('/TransformIncharge')
    @ApiQuery({name:'apiVersion'})
    @ApiQuery({name:'Inchargeid'})
    @ApiQuery({name:'InchargeUserid'})
    async transformIncharge(@Query() trsDto:TransformDto, @Req() request:Request):Promise<SingleResponseModel> {
        try {
            return await this.inchrgServ.transformIncharge(trsDto, request);
        } catch (error) {
            return errorHandler(SingleResponseModel, error);
        }
    }


    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })  
    @Post('/editChildIncharges')
    @ApiQuery({name:'apiVersion'})
    async editChildIncharges(@Query() queryParams,@Body() inchdto:ChildInchargeDto,@Req() request:Request): Promise<SingleResponseModel> {
        try {
            return await this.inchrgServ.editChildIncharges(queryParams,inchdto,request);
        } catch (error) {
            return errorHandler(SingleResponseModel, error);
        }
    }


    
            

}

